import AddRoleIndex from "../../pages/dashboard/roles/AddRoleIndex";
import EditRoleIndex from "../../pages/dashboard/roles/EditRoleIndex";
import RolesIndex from "../../pages/dashboard/roles/RolesIndex";
import ViewRoleIndex from "../../pages/dashboard/roles/ViewRoleIndex";
import { ALL_ROUTES } from "../AllRoutes";

export const all_roles_routes_group = [
  {
    path: ALL_ROUTES?.DASHBOARD_ROLES,
    element: RolesIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_ROLES_ADD,
    element: AddRoleIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_ROLES_VIEW,
    element: ViewRoleIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_ROLES_EDIT,
    element: EditRoleIndex,
  },
];
